import {openUserDrawer} from '@/modules/users/components/user-drawer/util'
import {ResourceTag, ResourceTagProps} from '@cypro/ui/components/ui/tags/resource-tag'
import {User} from '@cypro/engine/schema'
import {useTranslate} from '@tolgee/react'

export interface UserTagProps extends Omit<ResourceTagProps, 'onClick'> {
  user?: User
}

export function UserTag({user, children, ...props}: UserTagProps) {
  const {t} = useTranslate('common')

  return (
    <ResourceTag
      {...props}
      onClick={e => {
        e.stopPropagation()
        if (user) openUserDrawer(user)
      }}
      data-e2e="user-tag"
      data-user-id={user?.id}
    >
      {children}
      {!children && <>@{user?.username || t('unknown')}</>}
    </ResourceTag>
  )
}
